<template>
<div class="chapter">
<div class="inner_page">
<div class="media-group"><img alt="" src="images/9000f163coverc01a.jpg" width="86.38838%"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?1b3c876a